<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位号：</span>
        </div>
        <el-input v-model="formData.parkLotNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否固定车位：</span>
        </div>
        <el-select v-model="formData.fix" size="small" style="width: 280px">
          <el-option v-for="item in typeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位区域：</span>
        </div>
        <el-select v-model="areaCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择车位区域">
          <el-option v-for="item in parkingLotAreaList" :key="item.code"
                     :label="item.parkingLotAreaName" :value="item.code">
          </el-option>
        </el-select>              
      </div>  



      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-lot-add-one",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位管理"
        }
      ],
      mainTitle: "添加车位",
      subheading: "",

      typeList: [{ code: "true", name: "是" }, { code: "false", name: "否" }],
      formData: {
        parkLotNumber: "",
        fix: "",
        status: 0
      },
      parkingLotAreaList: [],
      areaCode: ""
    };
  },

  created() {
    this.remoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getParkingLotAreaList();
    },

    // 确认添加
    confirm() {
      if (!this.formData.parkLotNumber) {
        nError("请输入车位号");
        return false;
      }
      if (!this.formData.fix) {
        nError("请选择是否固定车位");
        return false;
      }
      if (!this.formData.areaCode) {
        nError("请选择车位区域");
        return false;
      }
      this.$axios
        .post(api.addParkingLot, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "parking-lot-manage"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "parking-lot-manage"
      });
    },
    getParkingLotAreaList() {
      this.$axios
        .post(api.getParkingLotAreaList, {})
        .then(res => {
          this.parkingLotAreaList = res.data.data;
        })
        .catch(errorHandler("获取车位区域列表失败"));
    }
  },
  watch: {
    areaCode(val) {
      console.log(val);
      this.parkingLotAreaList.map(v => {
        if (v.code == val) {
          this.formData.areaName = v.parkingLotAreaName;
          this.formData.areaCode = v.code;
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLot/ParkingLotAddOne.vue